import React, {useRef, useState} from "react";
import heroImg from "../../assets/img/home-hero-graphic.png";
import {Button, CardBody, CardHeader, Col, Container, CustomInput, Form, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText, Label, Row} from "reactstrap";
import {MotionCard} from "../../components/Core/MotionStrap";
import "../../assets/scss/tradein-front.scss";
import FormValidator from "../../lib/Utils/FormValidator";
import Notify from "../../lib/Utils/Alert";
import TradeIn from "../../lib/Core/Backend/Controllers/TradeIn";
import NotificationAlert from "react-notification-alert";

function Start()
{
	const [step, setStep] = useState("device");
	const addressForm = useRef();
	const notifRef = useRef();
	const years = [];
	const tradeinCtl = new TradeIn("");

	let selectedDevice = null;
	let snIMEI = null;

	for (let i = 1940; i < 2009; ++i)
		years.push(i);

	function startOver(e)
	{
		setStep("device");
	}

	function getSnIMEI(e)
	{
		selectedDevice = e.currentTarget.dataset.type;
		setStep("imei");
	}

	function showQuote(e)
	{
		snIMEI = document.getElementsByName("sn-imei")[0].value;
		setStep("quote");
	}

	function startSignUp(e)
	{
		setStep("signup");
	}

	const [regData, setRegData] = useState();

	function register()
	{
		const av = new FormValidator(addressForm.current, (type, message) => Notify(notifRef, type, message),
			[
				{label: "First Name", property: "firstName", required: true},
				{label: "Last Name", property: "lastName", required: true},
				{label: "Email", property: "username", required: true, type: "email"},
				{label: "Password", property: "password", required: true},
				{label: "Address 1", property: "addressLine1", required: true},
				{label: "Address 2", property: "addressLine2", required: false},
				{label: "Month of Birth", property: "birthMonth", required: false},
				{label: "Year of Birth", property: "birthYear", required: false},
				{label: "Phone", property: "phoneNumber", required: true, type: "phone"},
				{label: "City", property: "city", required: true},
				{label: "Postal or Zip Code", property: "postalCode", required: true},
				{label: "State", property: "state", required: true},
				{label: "Country", property: "country", required: true, noVal: "-1"},
				{label: "Acceptance of Terms and Conditions", property: "acceptTermsAndConditions", required: true, type: "check", noVal: false},
				{label: "Acceptance of Privacy Notice", property: "acceptPrivacyPolicy", required: true, type: "check", noVal: false}
			]
		);

		if (!av.isFormValid())
			return;

		const tmp = av.getDTO();
		tmp.userShippingAddress = {
			addressLine1: tmp.addressLine1,
			addressLine2: tmp.addressLine2,
			city: tmp.city,
			country: tmp.country,
			state: tmp.state,
			zipCode: tmp.zipCode
		};

		setRegData(tmp);

		tradeinCtl.signup(tmp, data =>
		{
			if (data.errorCode)
			{
				Notify(notifRef, "danger", data.errorMessage);
			} else
			{
				Notify(notifRef, "info", "Successfully registered, please check your email.");
				setStep("confirm-email");
			}
		});
	}

	function resendConfirmation()
	{
		tradeinCtl.resendConfirmation(regData.username, data =>
		{
			if (data.errorCode)
			{
				Notify(notifRef, "danger", data.errorMessage);
			} else
			{
				Notify(notifRef, "info", "The confirmation email was re-sent to your inbox, please check.");
			}
		});
	}

	function confirmEmail()
	{
		const codeInput = document.getElementById("confcode");

		tradeinCtl.verifyEmail(codeInput.value, regData.username, data =>
		{
			if (data.errorCode)
			{
				Notify(notifRef, "danger", data.errorMessage);
			} else
			{
				Notify(notifRef, "info", "Your account has been successfully created! (next steps will be seen on the upcoming sprint).");
				setStep("device");
			}
		});
	}

	return (
		<Container id="hero" fluid={false}>
			<NotificationAlert ref={notifRef}/>
			<Row className="justify-content-center text-center my-3">
				<Col md={12} style={{backgroundColor: "#cdcdcd"}} className="p-3">
					<h1>Trade In Your Device</h1>
					<p>And receive your choice of gift card payments as provided by Ncentiva</p>
					<div className="align-content-center">
						<a href="https://ncentiva.com/#how-it-works" target="_blank" rel="noreferrer">How It Works</a>
					</div>
					<img src={heroImg} className="mac-jumbotron-image img-responsive py-3" width="417" alt="hero graphic"/>
				</Col>
			</Row>
			<Row className="justify-content-center text-center">
				<MotionCard initial={{opacity: 0.0}} animate={{opacity: 1, transition: {type: "easein"}}} className="bg-light shadow border-0" width="100%">
					<CardHeader className="bg-danger text-center text-light py-3">
						Please provide all the information related to your device.
					</CardHeader>
					<CardBody className="px-lg-4 py-lg-4">
						{step === "device" &&
						<>
							<div className="device_item text-center">
								<button className="btn btn-type" data-type="apple_computer" type="button" onClick={getSnIMEI}>
									<span><img src="/tradein_files/devicetype_mac@2x.png" alt="Mac"/></span> Mac
								</button>
							</div>
							<div className="device_item text-center">
								<button className="btn btn-type" data-type="apple_tablet" type="button" onClick={getSnIMEI}>
									<span><img src="/tradein_files/devicetype_ipad@2x.png" alt="iPad"/></span> iPad
								</button>
							</div>
							<div className="device_item text-center">
								<button className="btn btn-type" data-type="apple_smartwatch" type="button" onClick={getSnIMEI}>
									<span><img src="/tradein_files/devicetype_smartwatch@2x.png" alt="Apple Watch"/></span> Apple Watch
								</button>
							</div>
							<div className="device_item text-center">
								<button className="btn btn-type" data-type="apple_phone" type="button" onClick={getSnIMEI}>
									<span><img src="/tradein_files/devicetype_iphone@2x.png" alt="iPhone"/></span> iPhone
								</button>
							</div>
							<div className="device_item text-center">
								<button className="btn btn-type" data-type="other_phone" type="button" onClick={getSnIMEI}>
									<span><img src="/tradein_files/devicetype_other_phone@2x.png" alt="Other Smartphone"/></span> Other Smartphone
								</button>
							</div>
							<div className="device_item text-center">
								<button className="btn btn-type" data-type="other_tablet" type="button" onClick={getSnIMEI}>
									<span><img src="/tradein_files/devicetype_other_tablet@2x.png" alt="Other Tablet"/></span> Other Tablet
								</button>
							</div>
							<div className="device_item text-center">
								<button className="btn btn-type" data-type="other_computer" type="button" onClick={getSnIMEI}>
									<span><img src="/tradein_files/devicetype_other_computer@2x.png" alt="Other Computer"/></span> Other Computer
								</button>
							</div>
							<div className="device_item text-center">
								<button className="btn btn-type" data-type="other_smartwatch" type="button" onClick={getSnIMEI}>
									<span><img src="/tradein_files/devicetype_other_wearable@2x.png" alt="Other Wearable"/></span> Other Wearable
								</button>
							</div>
						</>
						}
						{step === "imei" &&
						<>
							<FormGroup className="mb-6">
								<InputGroup className="input-group-alternative">
									<InputGroupAddon addonType="prepend">
										<InputGroupText>
											<i className="fas fa-hashtag text-primary"/>&nbsp;&nbsp;
										</InputGroupText>
									</InputGroupAddon>
									<Input placeholder="IMEI or Serial number" type="text" name="sn-imei"/>
								</InputGroup>
							</FormGroup>
							<div className="text-right">
								<Button type="button" className="my-4" color="primary" onClick={showQuote}>
									Next
								</Button>
							</div>
						</>
						}
						{step === "quote" &&
						<>
							<h1>Your Quote is: $ 666.00</h1>
							<div className="text-right">
								<Button type="button" className="my-4" color="danger" onClick={startOver}>Reject</Button>
								<Button type="button" className="my-4" color="primary" onClick={startSignUp}>Accept</Button>
							</div>
						</>
						}
						{step === "signup" &&
						<>
							<Form innerRef={addressForm}>
								<Row form>
									<Col md="4">
										<FormGroup>
											<Label for="username">Email</Label>
											<Input type="email" name="username" id="username" placeholder="Email" maxLength="250"/>
										</FormGroup>
									</Col>
									<Col md="4">
										<FormGroup>
											<Label for="firstName">First Name</Label>
											<Input type="text" name="firstName" id="firstName" placeholder="First Name" maxLength="70"/>
										</FormGroup>
									</Col>
									<Col md="4">
										<FormGroup>
											<Label for="lastName">Last Name</Label>
											<Input type="text" name="lastName" id="lastName" placeholder="Last Name" maxLength="70"/>
										</FormGroup>
									</Col>
								</Row>
								<Row form>
									<Col md="6">
										<FormGroup>
											<Label for="password">Password</Label>
											<Input type="password" name="password" id="password" placeholder="Password" maxLength="14" minLength="8"/>
										</FormGroup>
									</Col>
									<Col md="6">
										<FormGroup>
											<Label for="phoneNumber">Phone</Label>
											<Input type="tel" name="phoneNumber" id="phoneNumber" placeholder="Phone Number" maxLength="14"/>
										</FormGroup>
									</Col>
								</Row>
								<Row form>
									<Col md="6">
										<FormGroup>
											<Label for="birthMonth">Month of Birth</Label>
											<Input type="select" name="birthMonth" id="birthMonth" placeholder="Month">
												<option value="January">January</option>
												<option value="February">February</option>
												<option value="March">March</option>
												<option value="April">April</option>
												<option value="May">May</option>
												<option value="June">June</option>
												<option value="July">July</option>
												<option value="August">August</option>
												<option value="September">September</option>
												<option value="October">October</option>
												<option value="November">November</option>
												<option value="December">December</option>
											</Input>
										</FormGroup>
									</Col>
									<Col md="6">
										<FormGroup>
											<Label for="birthYear">Year of Birth</Label>
											<Input type="select" name="birthYear" id="birthYear" placeholder="Year">
												{years.map(item => <option value="{item}">{item}</option>)}
											</Input>
										</FormGroup>
									</Col>
								</Row>
								<Row form>
									<Col md={4}>
										<FormGroup>
											<Label for="addressLine1">Address 1</Label>
											<Input type="text" name="addressLine1" id="addressLine1" placeholder="Street name, number and internal number" maxLength="100"/>
										</FormGroup>
									</Col>
									<Col md={4}>
										<FormGroup>
											<Label for="addressLine2">Address 2</Label>
											<Input type="text" name="addressLine2" id="addressLine2" placeholder="Street name, number and internal number" maxLength="100"/>
										</FormGroup>
									</Col>
									<Col md={4}>
										<FormGroup>
											<Label for="city">City</Label>
											<Input type="text" name="city" id="city" placeholder="City" maxLength="50"/>
										</FormGroup>
									</Col>
								</Row>
								<Row form>
									<Col md={4}>
										<FormGroup>
											<Label for="state">State</Label>
											<Input type="text" name="state" id="state" placeholder="State" maxLength="50"/>
										</FormGroup>
									</Col>
									<Col md={4}>
										<FormGroup>
											<Label for="country">Country</Label>
											<Input type="select" name="country" id="country">
												<option value="-1">Select a country</option>
												<option value="USA">USA</option>
												<option value="Canada">Canada</option>
											</Input>
										</FormGroup>
									</Col>
									<Col md={4}>
										<FormGroup>
											<Label for="postalCode">Postal or Zip Code</Label>
											<Input type="text" name="postalCode" id="postalCode" placeholder="Zip Code" maxLength="7"/>
										</FormGroup>
									</Col>
								</Row>
								<Row form>
									<Col md={6}>
										<FormGroup>
											<CustomInput id="acceptTermsAndConditions" name="acceptTermsAndConditions" type="switch" label="I accept o have read and agreed to the terms and conditions"/>
										</FormGroup>
									</Col>
									<Col md={6}>
										<FormGroup>
											<CustomInput id="acceptPrivacyPolicy" name="acceptPrivacyPolicy" type="switch" label="I accept o have read and agreed to the privacy notice"/>
										</FormGroup>
									</Col>
								</Row>
								<div className="text-right">
									<Button type="button" className="my-4" color="primary" onClick={register}>Save details</Button>
								</div>
							</Form>
						</>
						}
						{step === "confirm-email" &&
						<>
							<FormGroup className="mb-6">
								<InputGroup className="input-group-alternative">
									<InputGroupAddon addonType="prepend">
										<InputGroupText>
											<i className="fas fa-hashtag text-primary"/>&nbsp;&nbsp;
										</InputGroupText>
									</InputGroupAddon>
									<Input placeholder="Confirmation code" type="text" id="confcode"/>
								</InputGroup>
							</FormGroup>
							<div className="text-right">
								<Button type="button" className="my-4" color="info" onClick={resendConfirmation}>
									Re-send confirmation email
								</Button>
								<Button type="button" className="my-4" color="primary" onClick={confirmEmail}>
									Confirm
								</Button>
							</div>
						</>
						}
					</CardBody>
				</MotionCard>
			</Row>
		</Container>
	);
}

export default Start;
